module.exports = __webpack_public_path__ + "static/media/user.3e4af0ac.png";